import { useEffect, useMemo } from 'react';
import { isEqual } from 'lodash';
import { useInstantSearch } from 'react-instantsearch';
import { usePrevious } from '@uncinc/uncinc-react-kitchen-sink';
var AnalyticsEvent = /*#__PURE__*/function (AnalyticsEvent) {
  AnalyticsEvent["Search"] = "searchkit_search";
  AnalyticsEvent["Refine"] = "searchkit_refine";
  return AnalyticsEvent;
}(AnalyticsEvent || {});
export const AnalyticsHandler = props => {
  const {
    indexName
  } = props;
  const {
    uiState
  } = useInstantSearch();
  const previousUIState = usePrevious(uiState[indexName]);

  /**
   * Based on available facets that have multiple values, build an object with
   * Dynamic properties based on the keys and indexes
   * 
   * @example
   * {
   *  search_facet__facet_name: "This is a facet, this is also a facet"
   * }
   */
  const buildFacetParams = function () {
    let refinements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const params = {};
    const keys = Object.keys(refinements);
    keys.forEach(key => {
      const value = refinements[key];
      if (Array.isArray(value)) {
        const parsedValue = value.sort().join(',');
        params["search_facet__".concat(key)] = parsedValue;
      } else {
        params["search_facet__".concat(key)] = value;
      }
    });
    return params;
  };

  /**
   * Build an analytics event 
   */
  const buildAnalyticsEvent = (eventName, query, menu, refinements) => {
    const searchFacetParams = buildFacetParams(menu);
    const searchRefinementsParams = buildFacetParams(refinements);
    return {
      event: eventName,
      search_query: query,
      ...searchFacetParams,
      ...searchRefinementsParams
    };
  };

  /**
   * Compare the query, menu and refinementlist with
   * The previous values as strings
   * If they differ, overwrite the previous values
   * And send an event to the dataLayer
   */
  const handleAnalyticsEvent = currentState => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    const currentQuery = currentState.query || '';
    const currentMenu = currentState.menu;
    const currentRefinementList = currentState.refinementList;
    const previousQuery = (previousUIState === null || previousUIState === void 0 ? void 0 : previousUIState.query) || '';
    const previousMenu = previousUIState === null || previousUIState === void 0 ? void 0 : previousUIState.menu;
    const previousRefinementList = previousUIState === null || previousUIState === void 0 ? void 0 : previousUIState.refinementList;
    const noFacetsSelected = !currentMenu && !currentRefinementList;
    if (currentQuery !== previousQuery && currentQuery && noFacetsSelected) {
      window.dataLayer.push(buildAnalyticsEvent(AnalyticsEvent.Search, currentQuery, currentMenu, currentRefinementList));
    } else if ((currentQuery !== previousQuery && currentQuery || !isEqual(currentMenu, previousMenu) || !isEqual(currentRefinementList, previousRefinementList)) && (currentMenu || currentRefinementList)) {
      window.dataLayer.push(buildAnalyticsEvent(AnalyticsEvent.Refine, currentQuery, currentMenu, currentRefinementList));
    }
  };
  const newState = useMemo(() => {
    if (!isEqual(uiState[indexName], previousUIState)) {
      return uiState[indexName];
    }
    return null;
  }, [uiState]);
  useEffect(() => {
    if (newState) {
      handleAnalyticsEvent(newState);
    }
  }, [newState]);
  return null;
};
export default AnalyticsHandler;